import { categories } from '@/mocks/categories';

export default function Hero() {
  const featuredCats = categories.slice(0, 4);

  return (
    <section className="relative w-full h-screen min-h-[700px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20product%20flat%20lay%20with%20colorful%20sneakers%20in%20coral%20pink%20mint%20green%20and%20soft%20yellow%2C%20oversized%20graphic%20hoodie%20in%20lavender%2C%20vintage%20denim%20jacket%2C%20sunglasses%20and%20gold%20chain%20accessories%20scattered%20on%20textured%20white%20marble%20surface%2C%20natural%20window%20light%20from%20left%20side%20creating%20soft%20directional%20shadows%2C%20modern%20streetwear%20aesthetic%20with%20pastel%20accents%2C%20high%20contrast%20editorial%20photography%2C%20clean%20minimal%20composition%20with%20intentional%20negative%20space%2C%20luxury%20lifestyle%20vibe%20with%20playful%20energy&width=1920&height=1080&seq=hero-hipobuy-v2-2025&orientation=landscape"
          alt="Hipobuy Spreadsheet product collage"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full flex flex-col items-center justify-center px-6 text-center mt-16">
        <h1 className="w-full max-w-4xl">
          <span className="block text-5xl md:text-7xl lg:text-[80px] font-bold text-white font-body tracking-tight leading-none">
            Hipobuy
          </span>
          <span className="block text-5xl md:text-7xl lg:text-[80px] font-heading italic text-white font-normal leading-none mt-1">
            Spreadsheet
          </span>
          <span className="block text-4xl md:text-6xl lg:text-[72px] font-bold text-white font-body tracking-tight leading-none mt-1">
            Hub
          </span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-white/80 font-body max-w-xl font-light">
          The ultimate product finding database and shopping resource guide. Discover, compare, and organize thousands of verified products.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore Hipobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-white/90 text-foreground-900 text-sm font-semibold hover:bg-white transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            View Complete Guides
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-white/70 text-xs font-body">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-300 text-sm"></i>
            Updated Spreadsheet Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-300 text-sm"></i>
            Product Category Organization
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-300 text-sm"></i>
            QC Research Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-300 text-sm"></i>
            Beginner Friendly
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 flex justify-center items-end pb-8 px-6">
        <div className="flex items-end gap-0 -mb-2">
          {featuredCats.map((cat, idx) => (
            <div
              key={cat.name}
              className="relative bg-white rounded-2xl px-5 py-4 shadow-sm border border-background-200 flex-shrink-0 cursor-pointer hover:-translate-y-1 transition-transform duration-300"
              style={{
                zIndex: featuredCats.length - idx,
                transform:
                  idx === 1
                    ? 'rotate(0deg) translateY(0px)'
                    : idx % 2 === 0
                    ? `rotate(${idx % 2 === 0 ? -2 : 2}deg) translateY(10px)`
                    : `rotate(${idx % 2 === 0 ? -2 : 2}deg) translateY(10px)`,
                marginLeft: idx === 0 ? '0' : '-12px',
              }}
            >
              <span className="text-xs font-medium text-foreground-600 font-body whitespace-nowrap">{cat.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}